var map = {
	"./black.png": 51852,
	"./blackBanner.png": 77846,
	"./blue.png": 48613,
	"./blueBanner.png": 3771,
	"./brown.png": 56985,
	"./brownBanner.png": 84503,
	"./green.png": 27804,
	"./greenBanner.png": 84550,
	"./orange.png": 82895,
	"./orangeBanner.png": 86629,
	"./white.png": 63446,
	"./whiteBanner.png": 98992,
	"./yellow.png": 18581,
	"./yellowBanner.png": 86603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64254;